import styled from '@emotion/styled';

export const ANIMATION_DURATION_MS = 300;

export const SlideUpContent = styled.div<{ isOpen: boolean }>`
  width: 100vw;
  height: 100vh;
  background: ${({ theme }) => theme.colors.neutrals.white};
  transform: translateY(${({ isOpen }) => isOpen ? '0' : '100%'});
  transition: transform ${ANIMATION_DURATION_MS}ms ease;
`;
